import { NavHeadingsKROEnum, NavHeadingsKRTZEum } from "../../../../contexts/krFormContext"

export const getNavHeadingsKRO = (is2007: boolean) => {
    var navHeadings = [
        { sectionId: NavHeadingsKROEnum.RegistrationNumber, sectionTitle: `${NavHeadingsKROEnum.RegistrationNumber + 1}. Numer ewidencyjny` },
        { 
            sectionId: NavHeadingsKROEnum.Location, 
            sectionTitle: `${NavHeadingsKROEnum.Location + 1}. ${is2007 ? "Lokalizacja osuwiska" : "Lokalizacja" }` 
        },
        { 
            sectionId: NavHeadingsKROEnum.Characteristics, 
            sectionTitle: `${NavHeadingsKROEnum.Characteristics + 1}. ${is2007 ? "Charakterystyka osuwiska" : "Charakterystyka" }` 
        },
        { 
            sectionId: NavHeadingsKROEnum.MorfologicalParameters, 
            sectionTitle: `${NavHeadingsKROEnum.MorfologicalParameters + 1}. ${is2007 ? "Parametry morfologiczne osuwiska" : "Parametry morfologiczne" }` 
        },
        { 
            sectionId: NavHeadingsKROEnum.Subsoil, 
            sectionTitle: `${NavHeadingsKROEnum.Subsoil + 1}. ${is2007 ? "Podłoże osuwiska" : "Podłoże" }` 
        },
        { sectionId: NavHeadingsKROEnum.ColluvialMaterial, sectionTitle: `${NavHeadingsKROEnum.ColluvialMaterial + 1}. Materiał koluwialny` },
        { sectionId: NavHeadingsKROEnum.WaterManifestation, sectionTitle: `${NavHeadingsKROEnum.WaterManifestation + 1}. Przejawy wód powierzchniowych i gruntowych w obrębie` },
        { sectionId: NavHeadingsKROEnum.GenesisAndAge, sectionTitle: `${NavHeadingsKROEnum.GenesisAndAge + 1}. Wiek i geneza osuwiska` },
        { sectionId: NavHeadingsKROEnum.LandUse, sectionTitle: `${NavHeadingsKROEnum.LandUse + 1}. Użytkowanie terenu w obrębie osuwiska` },
        { sectionId: NavHeadingsKROEnum.ThreatsAndDamage, sectionTitle: `${NavHeadingsKROEnum.ThreatsAndDamage + 1}. Powstałe szkody i zagrożenia` },
        { sectionId: NavHeadingsKROEnum.WorkPerformed, sectionTitle: `${NavHeadingsKROEnum.WorkPerformed + 1}. Rodzaje i zakres wykonywanych prac zabezpieczających` },
        { 
            sectionId: NavHeadingsKROEnum.ConductingObservation, 
            sectionTitle: `${NavHeadingsKROEnum.ConductingObservation + 1}. ${is2007 ? "Prowadzenie instrumentalnych prac monitoringowych" : "Prowadzenie obserwacji" }` 
        },
        { sectionId: NavHeadingsKROEnum.ResearchState, sectionTitle: `${NavHeadingsKROEnum.ResearchState + 1}. Stan badań` },
        { 
            sectionId: NavHeadingsKROEnum.MapSection, 
            sectionTitle: `${NavHeadingsKROEnum.MapSection + 1}. ${is2007 ? "Szkic (mapa) osuwiska" : "Mapa" }` 
        },
        { sectionId: NavHeadingsKROEnum.GeologicalCrossSection, sectionTitle: `${NavHeadingsKROEnum.GeologicalCrossSection + 1}. Przekrój geologiczny osuwiska` },
        { 
            sectionId: NavHeadingsKROEnum.PhotographicDocumentation, 
            sectionTitle: `${NavHeadingsKROEnum.PhotographicDocumentation + 1}. ${is2007 ? "Fotografia (-ie) osuwiska" : "Dokumentacja fotograficzna" }` 
        },
        { 
            sectionId: NavHeadingsKROEnum.SecurityOptions, 
            sectionTitle: `${NavHeadingsKROEnum.SecurityOptions + 1}. ${is2007 ? "Uwagi o możliwości zabezpieczenia oraz dodatkowe informacje" : "Informacje o możliwości zabezpieczenia oraz informacje dodatkowe" }` },
        { 
            sectionId: NavHeadingsKROEnum.ElaboratorsAndInstitutions, 
            sectionTitle: `${NavHeadingsKROEnum.ElaboratorsAndInstitutions + 1}. ${is2007 ? "Autor karty" : "Wypełniający kartę" }` 
        },
        { 
            sectionId: NavHeadingsKROEnum.ElaboratorsAndInstitutions, 
            sectionTitle: `${NavHeadingsKROEnum.ElaboratorsAndInstitutions + 2}. ${is2007 ? "Kategoria i numer uprawnień geologicznych" : "Kategoria i numer kwalifikacji geologicznych wypełniającego kartę" }` 
        },
        { 
            sectionId: NavHeadingsKROEnum.ElaboratorsAndInstitutions, 
            sectionTitle: `${NavHeadingsKROEnum.ElaboratorsAndInstitutions + 3}. ${is2007 ? "Instytucja" : "Instytucja reprezentowana przez wypełniającego kartę" }` 
        },
        { 
            sectionId: NavHeadingsKROEnum.CardCompletionDate, 
            sectionTitle: `${NavHeadingsKROEnum.CardCompletionDate + (is2007 ? 2 : 3)}. ${is2007 ? "Data wypełnienia" : "Data wypełnienia karty" }` 
        }
    ]

    if (!is2007) {
        var additionalHeading = { sectionId: NavHeadingsKROEnum.DeterminationDate, sectionTitle: `${NavHeadingsKROEnum.DeterminationDate + 3}. Data ustalenia` };
        navHeadings.splice(NavHeadingsKROEnum.CardCompletionDate + 1, 0, additionalHeading)
    }

    return navHeadings;
}

export const getNavHeadingsKRTZ = (is2007: boolean) => {
    var navHeadings = [
        { sectionId: NavHeadingsKRTZEum.RegistrationNumber, sectionTitle: `${NavHeadingsKRTZEum.RegistrationNumber + 1}. Numer ewidencyjny` },
        { 
            sectionId: NavHeadingsKRTZEum.MainCriterionForArea, 
            sectionTitle: `${is2007 ? NavHeadingsKRTZEum.MainCriterionForArea : NavHeadingsKRTZEum.MainCriterionForArea + 1}. ${is2007 ? "Główne kryteria wyznaczenia terenu" : "Główne kryterium wyznaczenia terenu" }` 
        },
        { 
            sectionId: NavHeadingsKRTZEum.ObservationInstructions, 
            sectionTitle: `${is2007 ? NavHeadingsKRTZEum.ObservationInstructions : NavHeadingsKRTZEum.ObservationInstructions + 1}. Wskazania dotyczące obserwacji` },
        { 
            sectionId: NavHeadingsKRTZEum.ElaboratorsAndInstitutions, 
            sectionTitle: `${is2007 ? NavHeadingsKRTZEum.ElaboratorsAndInstitutions : NavHeadingsKRTZEum.ElaboratorsAndInstitutions + 1}. ${is2007 ? "Autor karty" : "Wypełniający kartę" }` 
        },
        { 
            sectionId: NavHeadingsKRTZEum.ElaboratorsAndInstitutions, 
            sectionTitle: `${is2007 ? NavHeadingsKRTZEum.ElaboratorsAndInstitutions + 1 : NavHeadingsKRTZEum.ElaboratorsAndInstitutions + 2}. ${is2007 ? "Kategoria i numer uprawnień geologicznych" : "Kategoria i numer kwalifikacji geologicznych wypełniającego kartę" }` 
        },
        { 
            sectionId: NavHeadingsKRTZEum.ElaboratorsAndInstitutions, 
            sectionTitle: `${is2007 ? NavHeadingsKRTZEum.ElaboratorsAndInstitutions + 2 : NavHeadingsKRTZEum.ElaboratorsAndInstitutions + 3}. Instytucja` 
        },
        { 
            sectionId: NavHeadingsKRTZEum.CardCompletionDate, 
            sectionTitle: `${NavHeadingsKRTZEum.CardCompletionDate + (is2007 ? 1 : 3)}. ${is2007 ? "Data wypełnienia" : "Data wypełnienia karty" }` 
        }
    ]

    if (!is2007) {
        var additionalHeading1 = { sectionId: NavHeadingsKRTZEum.DeterminationDate, sectionTitle: `${NavHeadingsKRTZEum.DeterminationDate + 3}. Data ustalenia` };
        var additionalHeading2 = { sectionId: NavHeadingsKRTZEum.Location, sectionTitle: `${NavHeadingsKRTZEum.Location + 1}. Lokalizacja` };
        navHeadings.splice(NavHeadingsKRTZEum.CardCompletionDate, 0, additionalHeading1);
        navHeadings.splice(NavHeadingsKRTZEum.MainCriterionForArea - 1, 0, additionalHeading2)
    }

    return navHeadings;
}

    